import request from '@/utils/request'

export function fetchSupplementList(query) {
    return request({
        url: '/supplement/supplements',
        method: 'get',
        params: query
    })
}

export function uploadSupplementSignDoc(id, data) {
    return request({
        url: '/supplement/supplement/' + id + '/upload-sign-doc',
        method: 'post',
        data
    })
}

export function uploadSupplementRelationFile(id, data) {
    return request({
        url: '/supplement/relation/file/' + id + '/upload-file',
        method: 'post',
        data
    })
}

export function fetchSupplementDetail(id) {
    return request({
        url: '/supplement/supplement/' + id,
        method: 'get'
    })
}

export function exportSupplementCommitment(id, data) {
    return request({
        url: '/supplement/supplement/' + id + '/export-commitment',
        method: 'post',
        data
    })
}

export function deleteSupplementRelationFile(id, data) {
    return request({
        url: '/supplement/relation/file/' + id + '/delete-file',
        method: 'post',
        data
    })
}

export function submitSupplement(id, data) {
    return request({
        url: '/supplement/supplement/' + id + '/submit',
        method: 'post',
        data
    })
}

export function batchExportSupplement(data) {
    return request({
        url: '/supplement/supplements/batch-export',
        method: 'post',
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function checkSupplement(id, data) {
    return request({
        url: '/supplement/supplement/' + id + '/check',
        method: 'post',
        data
    })
}